import { useRouter } from 'next/router'
import { FALLBACK_LOCALE } from '_constants'
import { EnumUserLocale } from '../types/locale'

export const useUserLocale = () => {
  const router = useRouter()
  return (router.locale as EnumUserLocale) || FALLBACK_LOCALE
}
